// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xIWW","left":"styles_left__2NR-e","desktopActions":"styles_desktopActions__3slTl","title":"styles_title__3mmfj"};